import { render, staticRenderFns } from "./AssinanteEditTabPerfil.vue?vue&type=template&id=4ca36a00&"
import script from "./AssinanteEditTabPerfil.vue?vue&type=script&lang=js&"
export * from "./AssinanteEditTabPerfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports